import * as React from 'react';

import Base from './Base';

import uri from '../../../../assets/svgs/publication-step-1.svg';

interface Props {
  onRequestClose?: () => void;
}

const Step1: React.FunctionComponent<Props> = props => {
  const {onRequestClose} = props;
  return (
    <Base
      style={{marginBottom: 16}}
      uri={uri}
      title={'ストーリーが作成されました！'}
      description={'続いてエピソードをつくりましょう！'}
      onRequestClose={onRequestClose}
      width={278}
      height={97}
    />
  );
};

const propsAreEqual = () => true;

export default React.memo(Step1, propsAreEqual);
